import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/pl';

dayjs.extend(isoWeek);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
dayjs.locale('pl');

export const getWeekStart = (date = dayjs()) => {
  return dayjs(date).startOf('isoWeek');
};

export const getWeekEnd = (date = dayjs()) => {
  return dayjs(date).endOf('isoWeek');
};

export const getWeekDays = (weekStart) => {
  const start = dayjs(weekStart);
  const days = [];

  for (let i = 0; i < 7; i++) {
    const day = start.add(i, 'day');
    days.push({
      date: day,
      key: day.format('YYYY-MM-DD'),
      dayNumber: day.format('D'),
      dayName: day.format('ddd'),
      monthName: day.format('MMM'),
      fullDate: day.format('YYYY-MM-DD'),
      isToday: day.isSame(dayjs(), 'day'),
      isWeekend: day.day() === 0 || day.day() === 6,
      dayOfWeek: day.day(),
      isoWeekday: day.isoWeekday(),
    });
  }

  return days;
};

export const isDateInWeek = (date, weekStart) => {
  const start = dayjs(weekStart).startOf('day');
  const end = start.add(6, 'day').endOf('day');
  return dayjs(date).isBetween(start, end, 'day', '[]');
};

export const isSameDay = (date1, date2) => {
  return dayjs(date1).isSame(dayjs(date2), 'day');
};

export const formatDateRange = (start, end) => {
  const startDate = dayjs(start);
  const endDate = dayjs(end);

  if (startDate.isSame(endDate, 'month')) {
    return `${startDate.format('DD')} - ${endDate.format('DD MMM YYYY')}`;
  }

  if (startDate.isSame(endDate, 'year')) {
    return `${startDate.format('DD MMM')} - ${endDate.format('DD MMM YYYY')}`;
  }

  return `${startDate.format('DD MMM YYYY')} - ${endDate.format('DD MMM YYYY')}`;
};

export const isCurrentWeek = (weekStart) => {
  return dayjs(weekStart).isSame(dayjs().startOf('isoWeek'), 'week');
};

export const getDayFromDate = (date, weekDays) => {
  const targetDate = dayjs(date).format('YYYY-MM-DD');
  return weekDays.find((day) => day.fullDate === targetDate);
};
